import { render } from "./IncomesByGroups.vue?vue&type=template&id=c31e96a0&scoped=true"
import script from "./IncomesByGroups.vue?vue&type=script&lang=js"
export * from "./IncomesByGroups.vue?vue&type=script&lang=js"

import "./IncomesByGroups.vue?vue&type=style&index=0&id=c31e96a0&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c31e96a0"]])

export default __exports__